const GeneralInfosITM = () =>
  import(
    /* webpackChunkName: "GeneralInfosITM" */ `@/components/rapsotec/projects/project/details/itm-configuration/GeneralInfos.vue`
  );

const LowVoltageITM = () =>
  import(
    /* webpackChunkName: "LowVoltageITM" */ `@/components/rapsotec/projects/project/details/itm-configuration/LowVoltage.vue`
  );
const LightningITM = () =>
  import(
    /* webpackChunkName: "LightningITM" */ `@/components/rapsotec/projects/project/details/itm-configuration/Lightning.vue`
  );
const FireDetectionITM = () =>
  import(
    /* webpackChunkName: "FireDetectionITM" */ `@/components/rapsotec/projects/project/details/itm-configuration/FireDetection.vue`
  );
const RiskyLocalsITM = () =>
  import(
    /* webpackChunkName: "RiskyLocalsITM" */ `@/components/rapsotec/projects/project/details/itm-configuration/RiskyLocals.vue`
  );
const TablesITM = () =>
  import(
    /* webpackChunkName: "InspectionOverviewTables" */ `@/components/rapsotec/projects/project/details/partials/InspectionOverviewTables.vue`
  );
const ResultsITM = () =>
  import(
    /* webpackChunkName: "ResultsITM" */ `@/components/rapsotec/projects/project/details/itm-configuration/Results.vue`
  );
export default [
  {
    path: "general-infos",
    name: "general-infos",
    component: GeneralInfosITM,
  },
  {
    path: "low-voltage",
    name: "low-voltage",
    component: LowVoltageITM,
  },
  {
    path: "lightning",
    name: "lightning",
    component: LightningITM,
  },
  {
    path: "fire-detection",
    name: "fire-detection",
    component: FireDetectionITM,
  },
  {
    path: "risky-locals",
    name: "risky-locals",
    component: RiskyLocalsITM,
  },
  {
    path: "tables",
    name: "tables",
    component: TablesITM,
  },
  {
    path: "results/:resultTypeCode",
    name: "results",
    component: ResultsITM,
  },
];
